import MockAdapter from 'axios-mock-adapter'
import httpClient from './httpClient'
import { coursesData } from '@/assets/data/products'

// Dynamically import all course details from the data directory
const courseDetailsModules = import.meta.glob('/src/helpers/data/courses/*.js', { eager: true })

const courseDetails = Object.keys(courseDetailsModules).reduce((acc, path) => {
  const courseId = path.split('/').pop().replace('.js', '')
  // The module is imported with a `default` export
  acc[courseId] = courseDetailsModules[path].default
  return acc
}, {})

export default function configureFakeBackend() {
  console.log('%c FAKE BACKEND CONFIGURED', 'color: #0cbc87; font-weight: bold;')

  const mock = new MockAdapter(httpClient, { delayResponse: 200 })

  // Mock for getting all courses
  mock.onGet('/api/courses').reply((config) => {
    console.log('Fake Backend: Intercepted GET /api/courses', config.params)
    // You can add more sophisticated filtering here based on config.params if needed
    return [200, coursesData]
  })

  // Mock for getting a specific course by ID
  mock.onGet(/\/api\/courses\/.+/).reply((config) => {
    const id = config.url.split('/').pop()
    console.log(`Fake Backend: Intercepted GET /api/courses/${id}`)

    const course = courseDetails[id]

    if (course) {
      console.log(course)
      return [200, course]
    } else {
      // Fallback to the main coursesData array if no detail file is found
      const fallbackCourse = coursesData.find((c) => c.id === id)
      if (fallbackCourse) {
        return [200, fallbackCourse]
      }
    }

    return [404, { error: 'Course not found' }]
  })

  // Mock for login
  mock.onPost('/auth/login').reply((config) => {
    console.log('Fake Backend: Intercepted POST /auth/login')
    const { email, password } = JSON.parse(config.data)
    if (email === 'user@demo.com' && password === 'password') {
      return [
        200,
        {
          id: 1,
          name: 'Lori Stevens',
          email: 'user@demo.com',
          role: 'User',
          token: 'fake-jwt-token-for-user',
        },
      ]
    }
    if (email === 'admin@demo.com' && password === 'password') {
      return [
        200,
        {
          id: 2,
          name: 'Admin User',
          email: 'admin@demo.com',
          role: 'Admin',
          token: 'fake-jwt-token-for-admin',
        },
      ]
    }
    return [401, { error: 'Invalid credentials' }]
  })
}
